export enum LAYOUT_MODES {
  LIGHT = "light",
  DARK = "dark",
}

export enum CHATS_TABS {
  ARCHIVE = "acrhive",
  DEFAULT = "default",
}

export enum TABS {
  USERS = "pills-user",
  CHAT = "pills-chat",
  CHAT_SUP = "pills-chatsup",
  CONTACTS = "pills-contacts",
  CALLS = "pills-calls",
  BOOKMARK = "pills-bookmark",
  SETTINGS = "pills-setting",


  TEST = "pills-test",
  WORKPLACE = "pills-workplace",
  TASK = "pills-task",
}

export enum WpModes {
  Workplace = 1,
  Task = 2
}